import type { DefaultApi, KomboApplicationStageTransitionRequest } from "@/api";
import { KomboApplicationStageTransitionDefault } from "@/models/kombo_application_stage_transition_default";
import { KomboApplicationStageTransitionDefaults } from "@/models/kombo_application_stage_transition_defaults";
import type { State as RootState } from "@/stores";
import { type Module } from "vuex";
export interface State {
  stage_transitions_default?: KomboApplicationStageTransitionDefaults;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    stage_transitions_default: undefined,
  },
  actions: {
    async getStageTransitionsDefault({ commit }) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getStageTransitionsDefault();
      const transitions = new KomboApplicationStageTransitionDefaults(
        response.data.map(
          (transition: Partial<KomboApplicationStageTransitionDefault>) =>
            new KomboApplicationStageTransitionDefault(transition),
        ),
      );
      commit("setStageTransitionsDefault", transitions);
      return transitions;
    },
    async postStageTransitionsDefault(
      {},
      transitionRequest: KomboApplicationStageTransitionRequest[],
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      await api.postStageTransitionsDefault(transitionRequest);
      return;
    },
  },
  mutations: {
    setStageTransitionsDefault(
      state,
      transitions: KomboApplicationStageTransitionDefaults,
    ) {
      state.stage_transitions_default = transitions;
    },
  },
};
